import { ConversationEditInput } from '@modules/conversation-message/ConversationEditInput';
import { ConversationMessageEditor } from '@modules/conversation-message/ConversationMessageEditor';
import { useConversationEditor } from '@modules/conversation/hooks/useConversationEditor';
import { forwardRef, useEffect } from 'react';
import { ChatMessageListItem } from 'src/@types/chat';
import { useEditMessage } from 'src/sections/@dashboard/chat/ChatConversation/useEditMessage';
import { useChatConversationContext } from '../../ChatConversation/useChatConversationContext';

const InputComponent = forwardRef((props: any, ref) => (
  <ConversationMessageEditor {...props} ref={ref} />
));

type Props = {
  message: ChatMessageListItem;
  cancelEdition: () => void;
};

export const ChatMessageEditInput = ({ message, cancelEdition }: Props) => {
  const { editorConfig } = useChatConversationContext();

  const { editor } = useConversationEditor({
    editorConfig,
    conversationId: message._id,
  });

  const { editMessage } = useEditMessage({ channelId: message.channel });

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!editor || !message.content) return;
    editor.commands.setContent(message.content);
    editor.commands.focus();
  }, [editor]);

  const onSend = async () => {
    if (!editor || editor.isEmpty) return;

    const editedMessage = editor.getHTML();
    if (!editedMessage) return;
    await editMessage({
      channel: message.channel,
      id: message._id,
      content: editedMessage,
    });

    editor.commands.setContent('');
    cancelEdition();
  };

  return (
    <ConversationEditInput
      editor={editor}
      InputComponent={InputComponent}
      onSend={onSend}
      cancelEdition={cancelEdition}
    />
  );
};
